export enum RequestStatuses {
    Pending = 1,
    Validated = 2,
    Refused = 3,
    Closed = 4,
}
